export default {
  receipt_history: "سجل الإيصالات",
  search_placeholder: "ابحث عن الإيصال / الطلب / المطعم...",
  from: "من",
  to: "إلى",

  receipt_id: "رقم الإيصال",
  order_id: "رقم الطلب",
  restaurant: "المطعم",
  date: "التاريخ",
  total: "الإجمالي",
  status: "الحالة",
  action: "إجراء",
  view: "عرض",
  paid: "مدفوع",


  receipt_details: {
  title: "إيصال الطلب",
  no: "رقم الإيصال",
  restaurant: "المطعم",
  supplier: "المورد"
},
product: "المنتج",
qty: "الكمية",
price: "السعر",
discount: "الخصم",
total: "الإجمالي",
grand_total: "الإجمالي الكلي",
status: "الحالة",
paid: "مدفوع",
back: "رجوع",
print: "طباعة",
download_pdf: "تحميل PDF",
settlement: "التسوية",
system_generated: "تم إنشاؤه تلقائياً",
city: "المدينة",
phone: "الهاتف",
date: "التاريخ",
no_receipt: "لا يوجد إيصال",
receipt_error: "فشل تحميل الإيصال"


};